import { render } from "./aio-login-meta.vue?vue&type=template&id=5913b32f&scoped=true"
import script from "./aio-login-meta.vue?vue&type=script&lang=js"
export * from "./aio-login-meta.vue?vue&type=script&lang=js"

import "./aio-login-meta.vue?vue&type=style&index=0&id=5913b32f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5913b32f"]])

export default __exports__